<template lang="pug">
  .form-group
    label.form-switch
      input(type="checkbox" v-model="model" :disabled="disabled")
      i.form-icon
      | {{ label }}
      .float-right(v-if="help")
        .popover.popover-left
          a.c-hand.text-bold ?
          .popover-container
            .card
              .card-body {{ help }}
</template>

<script>
export default {
  props: {
    value: { type: Boolean, default: false },
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    help: String,
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
}
</script>
